import * as React from "react";
import { cn } from "lib/cn";

export type InputProps = { large?: boolean } & React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef(({ className, large, ...props }: InputProps, ref) => {
    return (
        <input
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            ref={ref as any}
            className={cn(
                "rounded-lg border border-solid border-[#c8c8c8] bg-[#eeeeee] px-2 py-2 placeholder-gray-400 focus:ring-2 focus:ring-brand-atlantic focus:outline-hidden",
                large && "text-xl",
                className,
            )}
            {...props}
        />
    );
});
